import { PRIVACY } from 'queries/query-keys';
import { useQuery } from '@tanstack/react-query';
import TeamMemberService from 'services/TeamMemberService';

export const useBlockedEmailsQuery = (enabled) => {
  return useQuery({
    queryKey: PRIVACY.BLOCKED_EMAILS,
    queryFn: TeamMemberService.getBlockedEmails,
    enabled,
    initialData: {
      blockIncomingEmailsFrom: [],
      blockOutgoingEmailsFrom: [],
      enableInternalEmailSync: false,
    },
  });
};
